export default __webpack_public_path__ + "images/fcbc01bc500af372cae2119bf65682cd.svg";